module.exports = __webpack_public_path__ + "img/2_138.abd93efb.png";